import classNames from "classnames";
import { forwardRef } from "react";

const prefix = "a-select";

const Select = forwardRef(({ className, disabled, emptyLabel, errors, options, value, ...props }, ref ) => {
  
  const componentClass = classNames(prefix, "bg-gray-100 h-10 rounded-lg py-2 px-3 w-[100%]", {
    [className]: className,
    "border-2 border-red-500": !!errors
  });

  return (
    <select 
      className={componentClass}
      disabled={disabled}
      ref={ref}
      value={value || ""}
      {...props}
    >
      {emptyLabel && <option
        disabled={true}
        value=""
      >{emptyLabel}</option>}

      {options?.map((o, i) => {
        if (typeof o === "object") {
          const { label, value, ...optProps } = o;
          return <option key={i} value={value || o} {...optProps}>{label || o}</option>
        }
        return <option key={i} value={o}>{o}</option>
      })}
    </select>
  );
});

export default Select;
